export const quotes = [
  {
    text: "Das Leben ist wie Fahrradfahren. Um das Gleichgewicht zu halten, musst du in Bewegung bleiben.",
    author: "Albert Einstein"
  },
  {
    text: "Was mich nicht umbringt, macht mich stärker.",
    author: "Friedrich Nietzsche"
  },
  {
    text: "Phantasie ist wichtiger als Wissen, denn Wissen ist begrenzt.",
    author: "Albert Einstein"
  },
  {
    text: "Der Weg ist das Ziel.",
    author: "Konfuzius"
  },
  {
    text: "Wer kämpft, kann verlieren. Wer nicht kämpft, hat schon verloren.",
    author: "Bertolt Brecht"
  },
  {
    text: "Auch aus Steinen, die einem in den Weg gelegt werden, kann man Schönes bauen.",
    author: "Johann Wolfgang von Goethe"
  },
  {
    text: "Es ist nie zu spät, das zu werden, was man hätte sein können.",
    author: "George Eliot"
  },
  {
    text: "Die Zukunft gehört denen, die an die Schönheit ihrer Träume glauben.",
    author: "Eleanor Roosevelt"
  },
  {
    text: "Erfolg besteht darin, dass man genau die Fähigkeiten hat, die im Moment gefragt sind.",
    author: "Henry Ford"
  },
  {
    text: "Man sieht nur mit dem Herzen gut. Das Wesentliche ist für die Augen unsichtbar.",
    author: "Antoine de Saint-Exupéry"
  },
  {
    text: "Sei du selbst die Veränderung, die du dir wünschst für diese Welt.",
    author: "Mahatma Gandhi"
  },
  {
    text: "Das Glück ist das einzige, was sich verdoppelt, wenn man es teilt.",
    author: "Albert Schweitzer"
  },
  {
    text: "Wer aufhört zu lernen, ist alt. Er mag zwanzig oder achtzig sein.",
    author: "Henry Ford"
  },
  {
    text: "Die beste Zeit, einen Baum zu pflanzen, war vor zwanzig Jahren. Die nächstbeste Zeit ist jetzt.",
    author: "Chinesisches Sprichwort"
  },
  {
    text: "Nicht weil es schwer ist, wagen wir es nicht, sondern weil wir es nicht wagen, ist es schwer.",
    author: "Seneca"
  },
  {
    text: "Der Pessimist sieht in jeder Gelegenheit die Schwierigkeit. Der Optimist sieht in jeder Schwierigkeit die Gelegenheit.",
    author: "Winston Churchill"
  },
  {
    text: "Tue erst das Notwendige, dann das Mögliche, und plötzlich schaffst du das Unmögliche.",
    author: "Franz von Assisi"
  },
  {
    text: "Leben ist das, was passiert, während du eifrig dabei bist, andere Pläne zu machen.",
    author: "John Lennon"
  },
  {
    text: "Wer nie einen Fehler gemacht hat, hat nie etwas Neues probiert.",
    author: "Albert Einstein"
  },
  {
    text: "Das Leben ist zu wichtig, um es ernst zu nehmen.",
    author: "Oscar Wilde"
  }
]